import { ExportToExcel } from "../models/export-to-excel.model";
import * as ExportToExcelActions from "../actions/export-to-excel.actions";

const initialState: ExportToExcel = {
  periods: {
    AandQOrder: "IAIA",
    annuals: true,
    currentquarter: "",
    firstEstimateYr: null,
    firstEstimatedYr: null,
    interims: true,
    selected_from: "",
    selected_to: "",
  },
  analytics: {
    allowedtypes: ["off"],
    default: "Analytics",
    name: "GrowthTypes",
    trendYear: "",
    type: "row",
    values: ["YoY%", "%" /*"Seq#", "Seq%", "YoY#", "Trend"*/],
  },
  adjustments: {
    missingDataSelected: "implied",
  },
  accountingBasis: {
    selectedBasis: "All",
  },
  sources: {
    brokerState: {
      "0": {
        id: "exB",
        name: "All Excluded Broker",
        values: [],
      },
      "1": {
        id: "nexB",
        name: "All Non Excluded Broker",
        values: [],
      },
    },
    type: "column",
    statements: {
      NMV: [],
      SCH: [],
      STD: [],
      SAR: {},
    },
    AllSourceData: {
      SelectedSources: [],
      ConsensusType: [],
      selected_cc_not_entitled: false,
      selected_excl_cc_not_entitled: false,
      excl_non_entitled: [],
      non_entitled: [],
      IncludeCustomConsensus: [],
      ExcludeCustomConsensus: [],
      Show_Only_Current: false,
      va_actuals: false,
      filings: false,
      historical_consensus: false,
    },
    CustomizedSources: {},
    empty_column: true,
    sort_column: "modeldatetime",
    sort_order: "desc",
    logic_based_consensus: false,
    refdate: null,
  },
  revisions: {
    changed_date: "",
    revision_date_list: [],
    type: "column",
    values: [],
    effectiveStart: "",
  },
  extras: {
    exportLegend: false,
    sendByMail: false,
    splitIntoTabs: false,
  },
};

export function exportToExcelReducer(
  state: ExportToExcel = initialState,
  action: ExportToExcelActions.Actions,
) {
  switch (action.type) {
    case ExportToExcelActions.SET_SOURCES_DATA:
      return {
        ...state,
        sources: { ...action.payload },
      };

    case ExportToExcelActions.SET_PERIODS_DATA:
      return {
        ...state,
        periods: { ...action.payload },
      };

    case ExportToExcelActions.SET_ANALYTICS_DATA:
      return {
        ...state,
        analytics: { ...action.payload },
      };

    case ExportToExcelActions.SET_ACCOUNTING_BASIS_DATA:
      return {
        ...state,
        accountingBasis: { ...action.payload },
      };

    case ExportToExcelActions.SET_REVISIONS_DATA:
      return {
        ...state,
        revisions: { ...action.payload },
      };

    case ExportToExcelActions.SET_EXTRAS_DATA:
      return {
        ...state,
        extras: { ...action.payload },
      };

    case ExportToExcelActions.SET_EXPORT_TO_EXCEL_DATA:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
